<app-lids *ngIf="AppResolutionType !== ResolutionType.Mobile" [businessId]="businessId"></app-lids>
<app-lids-mobile *ngIf="AppResolutionType === ResolutionType.Mobile" [businessId]="businessId"></app-lids-mobile>
